import { useTranslation } from 'react-i18next'
import { ButtonBase, Tooltip } from '../../components/generic.tsx'
import { Stack } from '../../components/Stack.tsx'
import { ids } from '../../ids.ts'
import { useMapState } from '../../states.ts'

export const MapStyleToggle = () => {
	const { t } = useTranslation()
	const mapStyle = useMapState((s) => s.mapStyle)
	const setBaseMapStyle = useMapState((s) => s.setMapStyle)
	return (
		<Stack width='100%' gap={0.5} center>
			{(['light', 'dark', 'satellite'] as const).map((style) => (
				<Tooltip key={style} title={t(($) => $.mapMode[style])}>
					<ButtonBase
						data-ta={ids.map.baseStyle.button(style)}
						aria-label={style}
						onClick={() => setBaseMapStyle(style)}
						sx={{
							backgroundImage: `url('/assets/mode-${style}.png')`,
							backgroundSize: 'cover',
							backgroundPosition: '50% 30%',
							width: '100%',
							height: 40,
							borderRadius: 1,
							outlineColor: mapStyle === style ? (t) => t.palette.mapStyleSelected : 'transparent',
							outlineWidth: 2,
							outlineOffset: -2,
							outlineStyle: 'solid',
						}}
					/>
				</Tooltip>
			))}
		</Stack>
	)
}
